(() => {
  const openCalculator = () => {
    if (!['#gotele-calculator', '#gotele-calculator-toggle'].includes(location.hash)) return;
    const panel = document.getElementById('gotele-calculator-toggle');
    if (panel) panel.open = true;
  };
  document.addEventListener('click', event => {
    const link = event.target.closest && event.target.closest('[data-gotele-open-calculator]');
    if (!link) return;
    const panel = document.getElementById('gotele-calculator-toggle');
    if (panel) panel.open = true;
  });
  window.addEventListener('hashchange', openCalculator);
  openCalculator();
  const media = window.matchMedia('(max-width: 767px)');
  const pauseHidden = () => document.querySelectorAll('.gotele-demo video').forEach(video => {
    const portrait = video.classList.contains('gotele-demo__portrait');
    if (portrait !== media.matches) video.pause();
  });
  media.addEventListener('change', pauseHidden);
})();
